import { useMemo } from "react";
import { AchievementUnlocked } from "../AchievementUnlocked";

export const Achievement4Content = ({ earnings }) => {
  const mediaItems = useMemo(() => {
    const media = [];
    if (earnings?.items?.length) {
      const item = earnings.items[0];
      media.push({
        image_url: item.getImgSource(),
        className: 'media-item-fixed-height'
      })
    }
    return media;
  }, [earnings]);


  return <AchievementUnlocked
    title={'NEW ITEM UNLOCKED!'}
    textLines={[
      'COMMON EMP PISTOL ADDED TO INVENTORY',
      'KEEP BATTLING TO UNLOCK MORE ITEMS',
    ]}
    mediaItems = { mediaItems }
  />
  
};